export default __webpack_public_path__ + "static/media/SQ.adc7d862.png";